import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root'
})
export class OrderCreationService {
  environment = EnvironmentService.environment

  constructor(private httpClient: HttpClient) { }

  // Replenishment Definitions: START
  getCustomers() {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/ForecastRulesManager/GetCustomers`);
  }
  ForecastAndReplenishmentRules(obj = {}) {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/ForecastRulesManager/ForecastAndReplenishmentRules`, obj);
  }
 
  getAllReplenishmentRules(userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/ForecastRulesManager/GetAllRules?userID=${userId}&customerID=${customerId}`);
  }

  fetchRuleDetails(userId = 100081, customerId = 42, ruleID: number) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/ForecastRulesManager/GetRuleDetail?userID=${userId}&customerID=${customerId}&ruleID=${ruleID}`);
  }

  fetchReplenishmentDetails(userId = 100081, customerId = 42, ruleID: number) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/ForecastRulesManager/GetReplenishmentDetail?userID=${userId}&customerID=${customerId}&ruleID=${ruleID}`);
  }

  addForecastRule(obj = {}) {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/ForecastRulesManager/AddForecastRule`, obj);
  }

  updateForecastRule(obj = {}) {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/ForecastRulesManager/UpdateForecastRule`, obj);
  }

  updateReplenishmentRule(obj = {}) {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/ForecastRulesManager/UpdateReplenishmentRules`, obj);
  }
  // Replenishment Definitions: END


  // AB Config: START

  getABConfigList(userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_list?userID=${userId}&customerID=${customerId}`);
  }

  getLocationsAvailable = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_loc_srch?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  getLocationsAssigned = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_subset_loc_def?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  moveLocationsRight = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/ins_ab_loc`, obj);
  }

  moveLocationsLeft = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/del_ab_loc`, obj);
  }

  getLeadTimesAvailable = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_ldtm_srch?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  getLeadTimesAssigned = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_ldtm_def?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  moveLeadTimesRight = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/ins_ab_ldtm`, obj);
  }

  moveLeadTimesLeft = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/del_ab_ldtm`, obj);
  }

  getItemsAvailable = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_itm_srch?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  getItemsAssigned = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_subset_itm_def?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  moveItemsRight = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/ins_ab_itm`, obj);
  }

  moveItemsLeft = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/del_ab_itm`, obj);
  }


  getSortableChosen = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_sort_def?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}`);
  }

  moveSortableRight = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/ins_ab_sort_flag`, obj);
  }

  moveSortableLeft = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/del_ab_sort`, obj);
  }

  getSuppliersAvailable = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_sup_srch?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  getSuppliersAssigned = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_sup_def?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  moveSuppliersRight = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/ins_ab_sup`, obj);
  }

  moveSuppliersLeft = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/del_ab_sup`, obj);
  }

  getClustersAvailable = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_clst_srch?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  getClustersAssigned = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_clst_def?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  moveClustersRight = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/ins_ab_clst`, obj);
  }

  moveClustersLeft = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/del_ab_clst`, obj);
  }

  getItemGroupsAssigned = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_itm_grp_def?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  moveItemGroupsRight = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/ins_ab_grp_itm`, obj);
  }

  moveItemGroupsLeft = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/del_ab_itm_grp`, obj);
  }

  getLocationGroupsAvailable = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_loc_grp_srch?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  getLocationGroupsAssigned = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_loc_grp_def?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  moveLocationGroupsRight = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/ins_ab_grp_itm`, obj);
  }

  moveLocationGroupsLeft = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/del_ab_loc_grp`, obj);
  }

  getItemLocationGroupsAvailable = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_itmloc_grp_srch?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  getItemLocationGroupsAssigned = (userId = 100081, customerId = 42, keyId1: any, keyId2: any, search = '') => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_ab_set_itmloc_grp_def?userID=${userId}&customerID=${customerId}&keyId1=${keyId1}&keyId2=${keyId2}&item=${search}`);
  }

  moveItemLocationGroupsRight = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/ins_ab_grp_itmloc`, obj);
  }

  moveItemLocationGroupsLeft = (obj = {}) => {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/del_ab_itmloc_grp`, obj);
  }

  // AB Config: END


  // Auto-Replenishment Definitions: START
  getAllProfiles(userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_auto_list?userID=${userId}&customerID=${customerId}`);
  }

  getSourceLookup(userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/lookups/get_ord_src_lov?userID=${userId}&customerID=${customerId}`);
  }

  getWareHouseLookup(userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/lookups/get_wms_whs_lov?userID=${userId}&customerID=${customerId}`);
  }

  fetchProfileDetails(keyId: any, userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_auto_header?userID=${userId}&customerID=${customerId}&keyId=${keyId}`);
  }

  fetchProfileStepDetails(keyId: any, userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Auto2Manager/get_auto_definition?userID=${userId}&customerID=${customerId}&keyId=${keyId}`);
  }

  saveUpdateAutoReplenishment(obj = {}) {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Auto2Manager/CRUDAutoDefinition`, obj);
  }
  // Auto-Replenishment Definitions: END


  // Schedule: START
  getAllSchedules(userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Schedule1Manager/get_schd_list?userID=${userId}&customerID=${customerId}`);
  }

  getScheduleDetails(spName: string, keyId: any, userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/Schedule1Manager/GetScheduleSp?spName=${spName}&userID=${userId}&customerID=${customerId}&keyId=${keyId}`);
  }

  addUpdateSchedule(obj = {}) {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/Schedule1Manager/CRUD_SCHD`, obj);
  }

  overrideSchedule(obj = {}) {
    return this.httpClient.put(`${this.environment.TargetBaseUrl}/Schedule1Manager/proc_schd_ovrd`, obj);
  }
  // Schedule: END


  // Order Release History: START
  getWMSHistory(userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/WmsManager/GetWMSHistory?userID=${userId}&customerID=${customerId}`);
  }
  // Order Release History: END


  // Order Release: START
  getWMSList(userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/WmsManager/GetWMSOpen?userID=${userId}&customerID=${customerId}`);
  }

  getCustomersAssign(keyId: any, userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/WmsManager/GetCustomersAssign?userID=${userId}&customerID=${customerId}&keyID=${keyId}`);
  }

  getSupplierAssign(keyId: any, userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/WmsManager/get_of_supplier_asgn?userID=${userId}&customerID=${customerId}&keyID=${keyId}`);
  }

  getWarehousesAssign(keyId: any, userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/WmsManager/GetWarehousesAssign?userID=${userId}&customerID=${customerId}&keyID=${keyId}`);
  }

  getOrderSourcesAssign(keyId: any, userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/WmsManager/GetOrderSourcesAssign?userID=${userId}&customerID=${customerId}&keyID=${keyId}`);
  }

  getLocationsAssign(keyId: any, userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/WmsManager/GetLocationsAssign?userID=${userId}&customerID=${customerId}&keyID=${keyId}`);
  }

  getItemsAssign(keyId: any, userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/WmsManager/GetItemsAssign?userID=${userId}&customerID=${customerId}&keyID=${keyId}`);
  }

  getOrderWell(userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/WmsManager/GetOrderWell?userID=${userId}&customerID=${customerId}`);
  }

  processCalculate(obj = {}) {
    return this.httpClient.put(`${this.environment.TargetBaseUrl}/WmsManager/ProcessCalculate`, obj);
  }
  // Order Release: END


  // Order Review: START
  getOrderReviewGridData(userId = 100081, customerId = 42) {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/OrderReviewManager4/GetOrderReviewGrid?userID=${userId}&customerID=${customerId}`);
  }
  // Order Review: END

  
  // Order Simukate: START
  OrderSimulateROCIdStatus = (id:any) => {
    return this.httpClient.get(`${this.environment.TargetBaseUrl}/OrderSimulateROC/GetRunIdStatus?Id=${id}`);
  }
  OrderSimulateROC(obj = {}) {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/OrderSimulateROC/OrderSimulateROC`, obj);
  }
  OrderSimulateROCGet(obj = {}) {
    return this.httpClient.post(`${this.environment.TargetBaseUrl}/OrderSimulateROC/GetByAuditLogId`, obj);
  }
  // Order Simukate: END
  
}
